import { WZStatus } from '../types/wz';

const IMMUTABLE_WZ_STATUSES = [WZStatus.RELEASED, WZStatus.RECEIVED];

const EDITABLE_WZ_STATUSES = [WZStatus.DRAFT, WZStatus.CONFIRMED, WZStatus.CANCELLED];

const EDITABLE_STATUS_TRANSITIONS: Record<WZStatus, WZStatus[]> = {
  [WZStatus.DRAFT]: [WZStatus.DRAFT, WZStatus.RELEASED, WZStatus.CANCELLED],
  [WZStatus.CONFIRMED]: [WZStatus.CONFIRMED, WZStatus.RELEASED, WZStatus.CANCELLED],
  [WZStatus.RELEASED]: [WZStatus.RELEASED],
  [WZStatus.RECEIVED]: [WZStatus.RECEIVED],
  [WZStatus.CANCELLED]: [WZStatus.CANCELLED],
};

export function isWZEditable(status?: WZStatus) {
  return !status || !IMMUTABLE_WZ_STATUSES.includes(status);
}

export function canShowWZEditAction(status: WZStatus) {
  return EDITABLE_WZ_STATUSES.includes(status);
}

export function getEditableWZStatusOptions(status?: WZStatus, isNewDocument = false) {
  if (isNewDocument) {
    return [WZStatus.DRAFT];
  }

  return EDITABLE_STATUS_TRANSITIONS[status || WZStatus.DRAFT];
}
